import { createStyles } from 'utils/css'
import theme from 'utils/theme'

export const formatIcon = createStyles(() => ({
  svg: {
    marginLeft: theme.spacing(0.5)
  }
}))
